import React from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

export default function Header() {
  const location = useLocation();
  const isDetailPage = /^\/detail\/[^/]+$/.test(location.pathname);

  return (
    <header className="border-b border-red-500 px-12 py-2">
      <div className="content flex items-center justify-between">
        <Link to="/">
          <img src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="" className="max-w-48" />
        </Link>
        {!isDetailPage && (
          <Link to="/history">
            Lịch sử
          </Link>
        )}
      </div>
    </header>
  );
}
